import { z } from "zod/v4";

import { AiNodeContextSchema } from "../context-schemas";
import { BaseNodeExecutionResultSchema } from "../node-execution-result";
import { ContextFilterSchema } from "../unified-context";

import {
  BaseNodeDefinitionConfigSchema,
  BaseNodeDefinitionSchema,
} from "./base-node";

// Zod schema for LLMFilterNodeResult
export const LLMFilterNodeResultSchema = BaseNodeExecutionResultSchema.extend({
  type: z.literal("llm-filter"),
  updatedContext: AiNodeContextSchema,
  generatedFilter: ContextFilterSchema,
});

// Zod schema for LLMFilterNodeConfig
export const LLMFilterNodeConfigSchema = BaseNodeDefinitionConfigSchema.extend({
  systemPrompt: z.string(),
  temperature: z.number().optional(),
  maxTokens: z.number().optional(),
});

// Zod schema for LLMFilterNodeDefinition
export const LLMFilterNodeDefinitionSchema = BaseNodeDefinitionSchema.extend({
  type: z.literal("llm-filter"),
  config: LLMFilterNodeConfigSchema,
});

// Inferred types from Zod schemas
export type LLMFilterNodeResult = z.infer<typeof LLMFilterNodeResultSchema>;
export type LLMFilterNodeDefinition = z.infer<
  typeof LLMFilterNodeDefinitionSchema
>;
export type LLMFilterNodeConfig = z.infer<typeof LLMFilterNodeConfigSchema>;
